export const ToastEnum = {
    Info: 'info',
    Error: 'error',
};
//# sourceMappingURL=ToastTypes.js.map